export default {
  methods: {
    isMobileDevice: function () {
      // return window.innerWidth < 604 || (/Mobi|Android/i.test(navigator.userAgent))
      let result =
        navigator.userAgent.match(/Android/i) ||
        navigator.userAgent.match(/webOS/i) ||
        navigator.userAgent.match(/iPhone/i) ||
        navigator.userAgent.match(/iPad/i) ||
        navigator.userAgent.match(/iPod/i) ||
        navigator.userAgent.match(/BlackBerry/i) ||
        navigator.userAgent.match(/Windows Phone/i)
      return result != null
    },
    isIphone: function () {
      let result = !!navigator.platform && /iPhone|iPod/.test(navigator.platform)
      return result
    }
  }
}
